module.exports = __webpack_public_path__ + "img/layout-10_1.37006e23.png";